export default "__VITE_ASSET__deb5bfab__"